export default __webpack_public_path__ + "static/media/small-logo.26b8c569.svg";